import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

const rankColor = (rank: number) => {
  if (rank === 1) return 'text-primary-500';
  if (rank === 2) return 'text-accent-600';
  if (rank === 3) return 'text-secondary-700';
  return 'text-foreground-300';
};

export default function RankingRow({ comic, rank }: { comic: Comic; rank: number }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group flex items-center gap-4 rounded-lg border border-transparent p-2 transition-colors hover:border-background-200 hover:bg-background-100/60"
    >
      <span className={`rank-number w-8 shrink-0 text-center text-2xl ${rankColor(rank)}`}>
        {rank < 10 ? `0${rank}` : rank}
      </span>

      <div className="relative h-16 w-12 shrink-0 overflow-hidden rounded-md">
        <img
          src={comic.cover}
          alt={`${comic.title} 好看的韩国漫画`}
          title={`${comic.title} 好看的韩国漫画`}
          className="h-full w-full object-cover object-top"
        />
      </div>

      <div className="min-w-0 flex-1">
        <h3 className="truncate font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
          {comic.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          <span className="text-foreground-600">{comic.genre}</span> · {comic.author}
        </p>
      </div>

      <div className="hidden items-center gap-2 sm:flex">
        {comic.tags.slice(0, 2).map((t) => (
          <span key={t} className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900">
            {t}
          </span>
        ))}
      </div>

      <div className="flex w-16 shrink-0 flex-col items-end">
        <span className="flex items-center gap-1 text-sm font-bold text-accent-600">
          <i className="ri-star-fill text-xs" />
          {comic.rating.toFixed(1)}
        </span>
        <span className="mt-1 text-xs text-foreground-400">热度 {comic.popularity}</span>
      </div>
    </Link>
  );
}